// @flow
const $ = require('jquery');
/**
 * options.next => (jQuery) objekt s nasledujici strankou
 * options.nextPage => (String) selector pro nasaledujici stranku
 * options.nextPageUrl => (String) URL nasledujici stranky
 * (obdobne pro 'previous')
 */

const PLUGIN_NAME = 'zusnaPagination';
const DEFAULTS = {
	dataContainer:     '#block-articles',				// element obsahujici nova data
	dataList:          '.article-list',					// element obsahujici nove clanky
	paginationElement: '.feed-pagination',				// element strankovani
	previousPage:      '.previous a',					// element odkazu na predchozi stranku
	nextPage:          '.next a',						// element odkazu na dalsi stranku
	debugMode:         false,							// zapnout/vypnout debug mod
	timestampedLog:    false,							// zapnuti/vypnuti casovych znacek v debug modu
	applyGrid:         true,							// zapnuti/vypnuti $.gridLayout() pluginu
};

// The actual plugin constructor
function ZusnaPagination(element, options) {
	this.element = element;

	this.options = $.extend({}, DEFAULTS, options);
	this.defaults = DEFAULTS;
	this.name = PLUGIN_NAME;
	this.init();
}

/**
 * init
 */
ZusnaPagination.prototype.init = function init() {
	const fn = this;

	fn.log(`Iniciace pluginu ${PLUGIN_NAME}`);

	// nacteni ostatnich potrebnych hodnot do pole options
	fn.options.me = $(fn.element);
	fn.options.pagination = $(fn.options.paginationElement);
	fn.options.next = fn.options.pagination.find(fn.options.nextPage);
	fn.options.previous = fn.options.pagination.find(fn.options.previousPage);

	fn.findPaginationUrl();
	fn.bindEvents();
};

ZusnaPagination.prototype.findPaginationUrl = function findPaginationUrl() {
	const fn = this;
	fn.log('FIND: findPaginationUrl()');
	fn.log(fn.options.pagination);
	fn.log(fn.options.next);
	fn.log(fn.options.previous);

	if (fn.options.next.length) {
		fn.options.nextPageUrl = fn.options.next.attr('href');
	} else {
		fn.options.nextPageUrl = '';
	}

	if (fn.options.previous.length) {
		fn.options.previousPageUrl = fn.options.previous.attr('href');
	} else {
		fn.options.previousPageUrl = '';
	}

	fn.log(`FIND: nextPageUrl nastaveno na ${fn.options.nextPageUrl}`);
	fn.log(`FIND: previousPageUrl nastaveno na ${fn.options.previousPageUrl}`);
};

ZusnaPagination.prototype.bindEvents = function bindEvents() {
	const fn = this;
	fn.log('BIND: bindEvents()');
	if ($(fn.options.next, fn.element)) {
		fn.log('BIND: nextPage');
		$(fn.options.next, fn.element).on(`click.${this.options.name}`, { fn }, fn.getNextUrl);
	}
	if ($(fn.options.previous, fn.element)) {
		fn.log('BIND: previousPage');
		$(fn.options.previous, fn.element).on(`click.${this.options.name}`, { fn }, fn.getPreviousUrl);
	}
};

ZusnaPagination.prototype.getNextUrl = function getNextUrl(event) {
	event.preventDefault();
	const { fn } = event.data;
	let listItems;
	let pagination;
	fn.log('----------------------');
	fn.log('GET NEXT: getNextUrl()');

	$.get(fn.options.nextPageUrl, (data) => {
		fn.log('GET NEXT: $.ajax().get()');
		listItems = $(`${fn.options.dataContainer} ${fn.options.dataList}`, data);
		pagination = $(`${fn.options.dataContainer} ${fn.options.paginationElement}`, data).parent(); // rodic ma nastavenou tridu pro grid
//			fn.log("GET NEXT: returned data: "+data);

		// vymena stavajiciho obsahu za novy
		fn.options.me.empty().append(listItems).append(pagination);

		if (fn.options.applyGrid && $().gridLayout()) {
			fn.log('GET NEXT: apply $.gridLayout()');

			fn.options.grid = $('.gridLayout', listItems.parent());
			fn.options.noNewImages = $('img', listItems).length;
			fn.options.imagesLoaded = 0;

			$('img', listItems).on('load', () => {
				// az budou nactene obrazky, aplikuj $.gridLayout()
				fn.log('GET NEXT: $.gridLayout - new img loaded');

				fn.options.imagesLoaded += 1;
				if (fn.options.imagesLoaded === fn.options.noNewImages) {
					fn.applyGridLayout();
				}
			});
		}

		// nahrazeni strankovacich odkazu
		fn.options.next = $(fn.options.nextPage, pagination);
		fn.options.previous = $(fn.options.previousPage, pagination);
		fn.findPaginationUrl();

		// fn.options.preloader.remove();
		fn.bindEvents();
	}).done(() => {
		fn.log('GET NEXT: $.ajax().done()');

		fn.scrollToMe();
	});
};

ZusnaPagination.prototype.getPreviousUrl = function getPreviousUrl(event) {
	event.preventDefault();
	const { fn } = event.data;
	let listItems;
	let pagination;
	fn.log('--------------------------');
	fn.log('GET PREV: getPreviousUrl()');

	$.get(fn.options.previousPageUrl, (data) => {
		fn.log('GET PREV: $.ajax().get()');
		listItems = $(`${fn.options.dataContainer} ${fn.options.dataList}`, data);
		pagination = $(`${fn.options.dataContainer} ${fn.options.paginationElement}`, data).parent(); // rodic ma nastavenou tridu pro grid
//			fn.log("GET PREV: returned data: "+data);

		// vymena stavajiciho obsahu za novy
		fn.options.me.empty().append(listItems).append(pagination);

		if (fn.options.applyGrid && $().gridLayout()) {
			fn.log('GET PREV: apply $.gridLayout()');

			fn.options.grid = $('.gridLayout', listItems.parent());
			fn.options.noNewImages = $('img', listItems).length;
			fn.options.imagesLoaded = 0;

			$('img', listItems).on('load', () => {
				// az budou nactene obrazky, aplikuj $.gridLayout()
				fn.log('GET PREV: gridLayout - new img loaded');

				fn.options.imagesLoaded += 1;
				if (fn.options.imagesLoaded === fn.options.noNewImages) {
					fn.applyGridLayout();
				}
			});
		}

		// nahrazeni strankovacich odkazu
		fn.options.next = $(fn.options.nextPage, pagination);
		fn.options.previous = $(fn.options.previousPage, pagination);
		fn.findPaginationUrl();

		// fn.options.preloader.remove();
		fn.bindEvents();
	}).done(() => {
		fn.log('GET PREV: $.ajax().done()');

		fn.scrollToMe();
	});
};

ZusnaPagination.prototype.applyGridLayout = function applyGridLayout() {
	const fn = this;

	fn.log('GRID: applyGridLayout()');

	const $grid = fn.options.grid;

	if (fn.options.grid.length) {
		try {
			if ($grid.length > 0) {
				$grid.gridLayout();
				$(window).resize(() => {
					$grid.gridLayout('resize');
				});
			}
		} catch (e) {
			if (window.console) console.trace(e);
		}
	}
};

ZusnaPagination.prototype.scrollToMe = function scrollToMe() {
	const fn = this;
	fn.log('SCROLL: scrollToMe()');
	$('body, html').animate({ scrollTop: 0 }, 700);
};

/**
 *  Provedeni zapisu do konzole, pokud je zapnuty debug mod
 *  @param    str        retezec, ktery se vypise v konzoli
 *  @return    void
 */
ZusnaPagination.prototype.log = function log(str) {
	const fn = this;
	if (fn.options.debugMode) {
		str = `${fn.name} > ${str}`;
		if (fn.options.timestampedLog) {
			const now = new Date();
			str = `${now.toLocaleTimeString()}.${now.getMilliseconds()} > ${str}`;
		}
		if (window.console) {
			console.log(str);
		} else {
			if ($(fn.element).find('.console').length === 0) {
				$(fn.element).append('<div class=\'console\'></div>');
			}
			$(fn.element).find('.console').append(`<p>${str}</p>`);
		}
	}
};

/**
 * decide, which methods will be "public"
 */
const API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *        if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[ PLUGIN_NAME ] = function plugin(value) {
	const args = arguments;

	return this.each((index, element) => {
		const $this = $(element);

		// get plugin instance
		let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

		// if there's not, create one
		if (!plugin) {
			plugin = new ZusnaPagination(this, value);
			$this.data(`plugin_${PLUGIN_NAME}`, plugin);
		} else if (API[ value ]) {
			// if there is and first parameter is in predefined API methods, call it with rest of params
			API[ value ].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.zusnaPagination.js